import React, { Component } from 'react';
import { connect } from 'react-redux';
import { currentWidget } from '../../../../action/action';
import { notificationColorConfig } from '../../../JS/colorConfig';
import moment from 'moment';
import clientConfigApi from '../../../../config/config';
import { guestJourneyNotification } from '../../../../action/homeAction';
import { Link } from "react-router-dom";
import $ from 'jquery'
import {withTranslation} from 'react-i18next'

class ReadMessage extends Component{

    constructor(props){
        super(props);
        this.state = {
          msgObj:{}
        }
        this.msgId = new URLSearchParams(this.props.location.search).get("id");
    }

    dateFormatHandler = (date) => {

        if (!date || date == null){
            return;
        }

        const dateObj = moment(date);
        return dateObj.format(`${this.props.dateFormat && this.props.dateFormat != "null" ? this.props.dateFormat.toUpperCase() : "YYYY-MM-DD"}`);
        // HH:mm:ss
    }

    formatMessageTextHandler = (text) => {
      if(!text){
        return [];
      }
      let htmlText = text.split('\n');
      console.log("formatted message text",htmlText)
      return htmlText;
    }

    readStatusHandler = (token,id) => {

        if(!token || token == null || !id || id == null){
            return;
        }
        
        try {
            clientConfigApi.put(
              "/textMessage/ack",
              {
                "header": {
                  "sessionToken": token,
                },
                "payload":{
                  "messages": [
                      {
                        "messageIds": [id],
                        "status": "READ"
                      }
                  ]   
                }
                
              }
            ).then((res) => {
              console.log("notifications acknowledgement", res);
              this.props.guestJourneyNotification(token);
            })
              .catch(
                ({ response = {} }) => {
                  console.log("Notification Api failed with the status code:", response.status);
                }
              )
          } catch (e) {
            console.log(`error in api call to path= "/textMessage/ack"`, e);
          }
    }

    componentWillUnmount(){
        this.props.currentWidget({})
    }

    componentDidUpdate(){
        notificationColorConfig(this.props.menuColor);
    }

    getObjHandler = (id) => {

      if(!id || id == null){
        return;
      }

      let msgObj = null;

      const sessionToken = localStorage.getItem('GuestJourneySessionToken');
      
      for (let obj of this.props.notifications){
        if (obj.id == id){
          msgObj = obj;
        }
      }

      // console.log("msg obJ",msgObj)

      this.setState({msgObj:msgObj});
      
      if(msgObj && msgObj.status === "NEW"){
        msgObj.status = "READ"
        this.readStatusHandler(sessionToken,msgObj.id);
      }

    }


    componentDidMount(){
        this.getObjHandler(this.msgId);
        this.props.currentWidget({widgetType:true});
        $("#read_msg_back").attr("style","color:#fff !important;");
        notificationColorConfig(this.props.menuColor);
    }

    render(){
      const {t} = this.props
        return(
            <div>
                <header id='notification-header' className="inner-pages w-footer no-bg" style = {{position:"sticky",top:"0",zIndex:"15"}}>
                    <Link exact to = "/notifications" className="button-back" id="read_msg_back"></Link>
                    <div className="heading">
                        <p className="sender-info heading">{t('notifications.from')} {this.state.msgObj.sender}</p>
                        <p className="sender-info">{t('notifications.date_sent')} {this.dateFormatHandler(this.state.msgObj.dateCreated)}</p>
                    </div> 
                </header>
                <section id="notifications" className="widgets paddin-bottom-6" style = {{marginBottom:"-5rem"}}>
                    <div className="widgets msg-section margin-top-1">
                        <form>
                            <div className="form-row">
                                <label for="message-contents" dangerouslySetInnerHTML={{__html: this.state.msgObj.messageTitle}} ></label>
                                <div className="message-contents" style = {{textAlign:"justify"}} >
                                    {this.formatMessageTextHandler(this.state.msgObj.messageText).map(el => (
                                      <p style={{margin:"0"}} dangerouslySetInnerHTML={{__html:el}} ></p>
                                    ))}
                                </div>
                            </div>
                        </form>
                    </div>
                </section>
                <footer className="button-controls">
                    <section className="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                        {/* <button className="primary w-100 all-caps margin-bottom-1">Reply</button> */}
                        <Link exact to = "/notifications">
                          <button className="secondary w-100 all-caps" >{t('notifications.close')}</button>
                        </Link>
                    </section>
                </footer>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
      menuColor: state.store.home.MenuColor,
      notifications: state.store.home.gJnotifications,
      dateFormat: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : ""
    }
  }


export default connect(mapStateToProps,{ currentWidget, guestJourneyNotification })(withTranslation('translations')(ReadMessage));